import * as THREE from 'three'


export default function createPlaneFromSection(sections) {
    let plane = new THREE.Plane()
    let v1 = getPointFromBufferGeometry(sections.geometry, 0)
    let v2 = getPointFromBufferGeometry(sections.geometry, 1)
    let v3 = getPointFromBufferGeometry(sections.geometry, 2)
    
    sections.localToWorld(v1)
    sections.localToWorld(v2)
    sections.localToWorld(v3)
    
    plane.setFromCoplanarPoints(v1, v2, v3)
    return plane
}

export function getPointFromBufferGeometry(bufferGeometry, index) {
    let position = bufferGeometry.attributes.position
    let x = position.getX(index)
    let y = position.getY(index)
    let z = position.getZ(index)
    return new THREE.Vector3(x, y, z)
}